var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"batch-card-show-details"},[(!_vm.isDetailsMode)?_c('div',{staticClass:"batch-card-show-details__icon",attrs:{"id":'batch-card-show-' + _vm.index}},[_c('router-link',{staticClass:"icon-container show",attrs:{"to":{
        path: `/print-tag/batches/${_vm.id}`,
        query: {
          orderPrintBy: _vm.orderBy
        }
      },"id":'batch-card-show-details-icon-' + _vm.index},on:{"click":_vm.handleTrackBatchDetails}},[_c('svg-loader',{attrs:{"src":"/static/images/icon-show-details.svg"}}),_vm._v(" "),_c('md-tooltip',{attrs:{"md-delay":"100","md-direction":"top"}},[_vm._v("\n        Mostrar amostras\n      ")])],1)],1):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }